package org.hs_soft.runmynesto.domain.model.home.options.cash_flow

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class IncomeExpansesInfoEnum(val title: String) {
    INC_EXPANSES_1(title = ""),
    INC_EXPANSES_2(title = ""),
    INC_EXPANSES_3(title = ""),
    INC_EXPANSES_4(title = ""),
    INC_EXPANSES_5(title = "");

    val titleShown: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                INC_EXPANSES_1 -> strings.incomeExpanses1
                INC_EXPANSES_2 -> strings.incomeExpanses2
                INC_EXPANSES_3 -> strings.incomeExpanses3
                INC_EXPANSES_4 -> strings.incomeExpanses4
                INC_EXPANSES_5 -> strings.incomeExpanses5
            }
        }
}